import React from 'react';
import PropTypes from 'prop-types';
import tracking from '@g4/g4-analytics';

import { getRawProducts } from '../Hotels/hotelsPageAnalytics';
import {
  GA4_EVENTS,
  RECOMMENDED,
} from '../../utils/constants/trackingConstants';

const TrackHotelProduct = ({
  hotel,
  room,
  sort,
  position,
  isLoading,
  children,
  trackViewItem,
  sortDescription,
}) => {
  React.useEffect(() => {
    const eventName = trackViewItem
      ? GA4_EVENTS.VIEW_ITEM
      : GA4_EVENTS.VIEW_ITEM_LIST;
    const impressionData = {
      id: hotel.id,
      name: sortDescription ?? RECOMMENDED,
      rawProducts: [getRawProducts(hotel, room, position)],
    };
    if (!isLoading) {
      tracking.trackViewItemList(eventName, impressionData);
    }
  }, [isLoading, position, sort, hotel, room, trackViewItem, sortDescription]);

  return children;
};

TrackHotelProduct.propTypes = {
  hotel: PropTypes.object,
  sort: PropTypes.string,
  position: PropTypes.number,
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  sortDescription: PropTypes.string,
};

TrackHotelProduct.defaultProps = {
  isLoading: false,
};

export default TrackHotelProduct;
